import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=32e8ab1a&"
import script from "./Link.vue?vue&type=script&lang=js&"
export * from "./Link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/mallgookoo-backstage-uat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32e8ab1a')) {
      api.createRecord('32e8ab1a', component.options)
    } else {
      api.reload('32e8ab1a', component.options)
    }
    module.hot.accept("./Link.vue?vue&type=template&id=32e8ab1a&", function () {
      api.rerender('32e8ab1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Sidebar/Link.vue"
export default component.exports